/**
 * TabbedDashLayout resolves `?tab=` by title before falling back to a positional index, so
 * links that target a specific device tab use these titles rather than an index that drifts
 * whenever DeviceDetails' tab array changes shape. Keep them in step with DeviceDetails.
 */
export const DeviceTab = {
    Status: "Status",
    Health: "Health",
    Camera: "Camera",
    MediaRequests: "Media Requests",
    Boundary: "Boundary",
    Fusion: "Fusion",
    Reports: "Reports",
    Errors: "Errors",
    Calibration: "Calibration",
    Upgrade: "Upgrade",
} as const;
